export const isMotionClass = (c) => c === 'motion' || c === 'occupancy' || c === 'presence';
const PANIC = /(?:^|[\s._-])panic(?:$|[\s._-])/i;
/**
 * Texecom panic-button zones (owner: "…_panic" zones are panic buttons, not
 * PIRs). Texecom reports them as device_class motion and zone_type "Guard",
 * so the entity id (or name) is the only tell; the id is checked first because
 * curated labels may call them "… motion".
 */
export const isPanicZone = (m) => m.domain === 'binary_sensor' && (PANIC.test(m.id) || PANIC.test(m.name));
const OPENING_CLASSES = new Set(['door', 'window', 'opening', 'garage_door', 'lock', 'vibration', 'tamper', 'smoke', 'moisture']);
const TEXECOM = /texecom/i;
/** texecom2mqtt / zone_type values that mean a detector rather than a contact. */
const PIR_ZONE_TYPE = /\b(?:pir|motion|detector|dual\s*tech)\b/i;
/**
 * A Texecom alarm PIR: a primary binary_sensor on the Texecom integration or a
 * Texecom device (texecom2mqtt rides on MQTT, so the device or the "Texecom …"
 * name is the tell), with a motion/occupancy/presence class (or, with no class,
 * a detector zone_type). Panic buttons and door/window contacts are excluded.
 */
export function isTexecomPir(m, device, attrs) {
    if (m.domain !== 'binary_sensor' || m.category !== null || isPanicZone(m))
        return false;
    const friendly = typeof attrs?.['friendly_name'] === 'string' ? attrs['friendly_name'] : '';
    const texecom = m.platform === 'texecom'
        || TEXECOM.test(`${device?.manufacturer ?? ''} ${device?.name ?? ''} ${device?.model ?? ''}`)
        || /^texecom\b/i.test(m.name) || /^texecom\b/i.test(friendly);
    if (!texecom)
        return false;
    if (PANIC.test(friendly))
        return false;
    const cls = m.deviceClass ?? (typeof attrs?.['device_class'] === 'string' ? attrs['device_class'] : null);
    if (cls)
        return isMotionClass(cls) && !OPENING_CLASSES.has(cls);
    const zoneType = attrs?.['zone_type'];
    return typeof zoneType === 'string' && PIR_ZONE_TYPE.test(zoneType);
}
//# sourceMappingURL=alarm-zones.js.map